import request from '../request';

export function index(params) {
  return request({
    url: "/driver/manage-income-deliveries",
    method: "get",
    params
  })
}

export function store(data) {
  return request({
    url: "/driver/manage-income-deliveries",
    method: "post",
    data
  })
}
